// core version + navigation, pagination modules:
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
// import Swiper and modules styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// init Swiper:
export const swiper = new Swiper('.swiper-gain-more', {
  // configure Swiper to use modules
  modules: [Navigation, Pagination],
  slidesPerView: 'auto',
  centeredSlides: true,
  slidesOffsetBefore: -40, // adjust this value to control the offset
  spaceBetween: 20, // adjust this

  breakpoints: {
    992: {
      slidesPerView: 4,
      centeredSlides: false,
      spaceBetween: 30,
      slidesOffsetBefore: 0,
    },
  },
})

